import React from "react";
import { Card, CardBody, Col } from "reactstrap";
import { toast } from "react-toastify";
import { connect } from "react-redux";
// Api
import {
  post_new_job,
  update_job
} from "../../../redux/middlewares/Jobs/post_job";
// Redux
import store from "../../App/store";
import { fillForm } from "../../../redux/actions/jobsActions";

// assets
import "./EditJob.style.scss";

// Components
import JobForm from "./jobDetails";
import { getCompanyWithId } from "../../../redux/middlewares/Company/getCompany";

class EditJob extends React.Component {
  constructor(Props) {
    super(Props);
    this.state = {
      loading: false,
      imageURL: "",
      jobDetails: {},
      companyDetails: {},
      clearInputs: false,
      success: false,
      formCompleted: false,
      changed: false,
      page: 0,
      error: "",
      photos: [],
      emptyFields: {}
    };
  }

  componentDidUpdate(prevProps, prevState) {
    // console.log(this.props);

    if (this.props.error !== prevProps.error) {
      this.setState({ loading: this.props.loading });
      toast.error(this.props.error || "Oops, Something went wrong!");
    }
    if (this.props.success !== prevProps.success) {
      console.log(this.props);
      store.dispatch(fillForm({}));
      if (this.props.success) {
        toast.success("Job Updated Successfully.");
        setTimeout(() => {
          window.location.reload();
        }, 3000);
        this.setState({
          success: this.props.success,
          loading: false,
          clearInputs: true,
          page: 0
        });
      }
    }
  }

  componentDidMount() {
    const { job } = { ...this.props };
    // if (job && job.company?.id) {
    //   getCompanyWithId(job.company.id)
    //     .then(doc => {
    //       if (doc.exists) {
    //         this.setState({ companyDetails: doc.data() });
    //       } else alert("Company doesn't Exists.");
    //     })
    //     .catch(error => alert(error.message));
    // }
  }

  // Setting jObDetails state to the object coming
  // from JobFrom.
  onCompleteForm = object => {
    console.log("Changed Object----", object);
    this.setState({ jobDetails: { ...object }, error: "", changed: true });
  };

  // Checking if the any field is empty
  isEmpty = obj => {
    console.log(obj);
    // return false;
    if (Object.keys(obj).length === 0) {
      return true;
    }

    let emptyObj = {};
    for (const key in obj) {
      if (obj[key] == "" || obj[key] === null || obj[key] === undefined) {
        emptyObj[key] = obj[key];
      }
    }
    this.setState({ emptyFields: emptyObj });
    // console.log({ emptyObj });
    return Object.values(emptyObj).length > 0;
    //   if (value == "" || value === null || value === undefined) {
    //     return true;
    //   }
    // });
    // return Object.values(obj).some(
    //   value => value == "" || value === null || value === undefined
    // );
  };

  // Submit Job (Object is coming from JobForm Component).
  onSubmitHandler = async event => {
    event.preventDefault();
    // if (this.state.page === 0) {
    this.setState({ loading: true });
    const { jobDetails } = { ...this.state };
    const requiredFields = { ...jobDetails };
    delete requiredFields.jobSalary;
    // delete requiredFields.companyStatement;
    // delete requiredFields.companyDescription;
    // delete requiredFields.companyConfirmationEmail;
    // delete requiredFields.companyHQ;
    // console.log(this.isEmpty(requiredFields));
    if (!this.isEmpty(requiredFields)) {
      // console.log("Bypass");
      this.setState(({ page }) => ({
        formCompleted: true
      }));
      // console.log({ jobDetails });
      store.dispatch(fillForm(jobDetails));
      this.props.update_job(this.state.jobDetails);
    } else {
      this.setState(
        {
          loading: false,
          error: "Please fill out All Required Fields"
        },
        () => window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
      );
    }
  };

  render() {
    // console.log({ loading: this.state.loading });
    return (
      <Col md={12}>
        <Card>
          <CardBody>
            <div className="form-inner">
              <form onSubmit={this.onSubmitHandler}>
                <JobForm
                  error={this.state.error}
                  clearInputs={this.state.clearInputs}
                  initialData={this.props.job}
                  // initialCompanyData={this.props.company}
                  emptyFields={this.state.emptyFields}
                  onCompleteForm={object => this.onCompleteForm(object)}
                />

                <div className="post-job-bottom" style={{ display: "flex" }}>
                  <div className="job-submit-btn">
                    <button
                      disabled={this.state.loading || !this.state.changed}
                      style={
                        this.state.loading || !this.state.changed
                          ? { backgroundColor: "#efefef", cursor: "default" }
                          : void 0
                      }
                    >
                      {this.state.loading ? "Loading..." : "Update"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = state => {
  // console.log(state);
  return {
    loading: state.jobReducer.loading,
    success: state.jobReducer.success
  };
};

export default connect(mapStateToProps, { post_new_job, update_job })(EditJob);
